import React, { useState, useEffect, useCallback } from 'react';
import KycVerification from '../components/KycVerification';
import './DashboardPage.css'; // Reusing some section styles

function KycPage() {
    const [user, setUser] = useState({
        id: '',
        name: '',
        kycStatus: ''
    });
    const [isLoading, setIsLoading] = useState(true);
    const API_URL = process.env.REACT_APP_API_URL || '';

    const fetchProfile = useCallback(() => {
        const session = JSON.parse(localStorage.getItem('userSession'));
        if (session && session.userId) {
            setIsLoading(true);
            fetch(`${API_URL}/api/auth/profile/${session.userId}`)
                .then(res => res.json())
                .then(data => {
                    if (data.success) {
                        setUser({
                            id: data.user.id,
                            name: data.user.name,
                            kycStatus: data.user.kycStatus
                        });
                    }
                })
                .catch(err => console.error('Error fetching profile for KYC:', err))
                .finally(() => setIsLoading(false));
        }
    }, [API_URL]);

    useEffect(() => {
        fetchProfile();
    }, [fetchProfile]);

    if (isLoading && !user.id) {
        return (
            <div className="dashboard-page-new" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                <div style={{ textAlign: 'center' }}>
                    <div className="loading-spinner" style={{ border: '4px solid rgba(247, 189, 32, 0.1)', borderTop: '4px solid #f7bd20', borderRadius: '50%', width: '40px', height: '40px', animation: 'spin 1s linear infinite', margin: '0 auto 1rem' }}></div>
                    <p style={{ color: '#666' }}>Loading verification details...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard-page-new">
            <div className="welcome-section" style={{ marginBottom: '2rem' }}>
                <div>
                    <h1>Identity Verification</h1>
                    <p className="welcome-subtitle">Complete your KYC to unlock all features</p>
                </div>
            </div>

            <div className="content-section">
                <KycVerification
                    userId={user.id}
                    environment="sandbox"
                    onComplete={() => {
                        console.log('KYC Completed successfully!');
                        setTimeout(fetchProfile, 2000);
                    }}
                />
            </div>

            {user.kycStatus === 'completed' && (
                <div className="content-section" style={{ marginTop: '2rem', textAlign: 'center' }}>
                    <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', padding: '1.5rem', borderRadius: '16px', color: '#166534' }}>
                        <h3>✨ You're all set!</h3>
                        <p>Your identity has been verified. You can now apply for loans and access premium features.</p>
                    </div>
                </div>
            )}
        </div>
    );
}

export default KycPage;
